import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { compileKeysObject, senderRow } from "../Utils/utils";
import style from "./allFinalStyle.module.css";
import Preloader from "../preLoader/Preloader";

export const SenderComponent = () => {
  return (
    <>
      <SendResult />
    </>
  );
};

const SendResult = ({}) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const { answers } = useSelector((state) => state.answers);
  const finalArray = compileKeysObject(answers);
  const data = new Date().toLocaleString();

  useEffect(() => {
    axios
      .post(senderRow(data, finalArray))
      .then((r) => setIsSuccess(true))
      .catch((e) => console.log(e));
  }, []);
  return (
    <>
      {!isSuccess ? (
        <div style={{ textAlign: "center" }}>
          <h2 className={style.finalH2}>
            Отправка данных займет некоторое время, пожалуйста подождите
          </h2>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <Preloader />
          </div>
        </div>
      ) : (
        <div style={{ textAlign: "center" }}>
          <h3>Успешно!</h3>
          Спасибо за Ваш ответ!
        </div>
      )}
    </>
  );
};
